import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { Typography, makeStyles } from '@material-ui/core';
import CustomButton from '../../shared/customButton';
import { useTranslations } from '../../../utility/useTranslations';
import { APP_PAGES } from '../../../constants/pages';
import BackgroundContainer from '../../shared/backgroundContainer';
import { getSubdomain } from '../../../utility/uiUtils';
import StorageService from '../../../utility/storageService';
import { TWO_FACTOR_AUTH } from '../../../utility/http';

const useStyles = makeStyles(
  ({ palette: { primary }, spacing, breakpoints }) => ({
    wrap: {
      height: 315,
      [breakpoints.up('xLg')]: {
        height: 315,
      },
      [breakpoints.up('xl')]: {
        height: 315,
      },
    },
    blockButton: {
      minHeight: 92,
      height: 92,
      '& span': {
        color: primary.bluish1,
        fontSize: 18,
        lineHeight: '20px',
        textTransform: 'none',
      },
    },
    description: {
      maxHeight: 'fit-content',
      padding: spacing(14, 14, 9, 14),
    },
    block: {
      padding: spacing(0, 14, 14, 14),
      height: 'fit-content',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'grid',
      gridGap: 8,
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      [breakpoints.up('xLg')]: {
        gridGap: 16,
      },
    },
  })
);

const TwoFactorOptionsPage = ({ auth, organizationSettings }) => {
  const navigate = useNavigate();
  const translations = useTranslations(APP_PAGES.TWO_FACTOR_OPTIONS_PAGE);

  const classes = useStyles();
  const subDomain = getSubdomain(window.location.hostname);
  const is2FARequired =
    organizationSettings?.is_2fa_required && !!auth?.has_2fa_enabled;

  const description = is2FARequired
    ? translations.descriptionReset
    : translations.descriptionDisable;
  const buttonLabel = is2FARequired ? translations.reset : translations.disable;

  return (
    <BackgroundContainer
      customWrapClass={classes.wrap}
      translations={translations.authContainer}
      removeTopButton
      subDomain={subDomain}
    >
      <>
        <div className={classes.description}>
          <Typography variant="body1">{translations.descriptionOne}</Typography>
          <Typography variant="body1">{translations.descriptionTwo}</Typography>
          <Typography variant="body1">
            {description.descriptionThree}
          </Typography>
          <Typography variant="body1">{description}</Typography>
        </div>
        <div className={classes.block}>
          <CustomButton
            className={classNames(
              classes.blockButton,
              classes.preferenceButton
            )}
            type="textRoundedLarge"
            onClick={() => navigate('/2fa/disable')}
          >
            {buttonLabel}
          </CustomButton>
          <CustomButton
            className={classNames(
              classes.blockButton,
              classes.preferenceButton
            )}
            type="textRoundedLarge"
            onClick={() => {
              StorageService.remove(TWO_FACTOR_AUTH);
              navigate('/');
            }}
          >
            {translations.continue}
          </CustomButton>
        </div>
      </>
    </BackgroundContainer>
  );
};

export default TwoFactorOptionsPage;
